exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attachment[data-v-279add2a]{width:12.5rem;height:11.25rem;border-radius:.625rem;object-fit:cover}", ""]);

// exports
